"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const errors_1 = require("./errors");
class Subscription {
    constructor({ name, params, onReady, onStop }) {
        this.name = name;
        this.params = params || [];
        this.onReady = (0, utils_1.once)(onReady);
        this.onStop = (0, utils_1.once)(onStop);
        this.wasCanceled = false;
    }
    ready() {
        if (this.wasCanceled) {
            return;
        }
        this.onReady();
        if (this.cb) {
            this.cb();
        }
    }
    nosub(error) {
        if (this.wasCanceled) {
            return;
        }
        const err = error && new errors_1.DDPError(error.error, error.reason, error.details);
        this.onStop(err);
        if (this.cb) {
            this.cb(err);
        }
    }
    cancel() {
        this.wasCanceled = true;
        this.onStop();
    }
    setCallback(cb) {
        this.cb = (0, utils_1.once)(cb);
    }
    toDDPMessage(id) {
        const { name, params } = this;
        return {
            id,
            name,
            params,
            msg: 'sub',
        };
    }
}
exports.default = Subscription;
//# sourceMappingURL=Subscription.js.map